/** Static copy for the Account Settings cards; tooltip strings are approved copy and must match the design exactly. */

export const DAILY_ORDER_LIMIT_TOOLTIP =
  "Maximum number of orders you can place within a 24-hour period. If you would like to increase this number, please reach out to RPI Customer Support team at printapicustomersupport@rpiprint.com.";

export const QUEUED_ORDER_LIMIT_TOOLTIP =
  "The maximum number of orders that can be queued, exceeding the Daily Order Limit. Any new orders that go beyond this limit will not be accepted.";

export const PAYMENT_METHOD_DESCRIPTION_PREFIX =
  "The payment amount will be the sum of all orders placed during the billing cycle. You can find additional information regarding payments in our ";

export const PAYMENT_METHOD_TERMS_LINK_LABEL = "terms & conditions";

/** Placeholder shown for an organization field that has no value yet. */
export const EMPTY_FIELD_PLACEHOLDER = "-";
